import config from 'config/global';
import { serialize } from 'utils/utils';
import { CALL_API, Schemas } from '../middleware/api';

export const TYPES = {
  SEARCH_RESULTS_REQUEST: 'SEARCH_RESULTS_REQUEST',
  SEARCH_RESULTS_SUCCESS: 'SEARCH_RESULTS_SUCCESS',
  SEARCH_RESULTS_FAILURE: 'SEARCH_RESULTS_FAILURE',
  SEARCH_TOPPER_REQUEST: 'SEARCH_TOPPER_REQUEST',
  SEARCH_TOPPER_SUCCESS: 'SEARCH_TOPPER_SUCCESS',
  SEARCH_TOPPER_FAILURE: 'SEARCH_TOPPER_FAILURE',
  SEARCH_RESULTS_INIT: 'SEARCH_RESULTS_INIT',
  SEARCH_RESULTS_PAGINATE: 'SEARCH_RESULTS_PAGINATE',
  SEARCH_RESULTS_UPDATE: 'SEARCH_RESULTS_UPDATE',
};

export const loadSearchResults = (params) => {
  const defaultParams = {
    page: 1,
    state: '',
    url: '/holidays/',
    pageStart: 0,
    results: 10,
    noNav: 1,
  };

  return {
    [CALL_API]: {
      types: [TYPES.SEARCH_RESULTS_REQUEST, TYPES.SEARCH_RESULTS_SUCCESS, TYPES.SEARCH_RESULTS_FAILURE],
      schema: Schemas.SEARCH_RESULTS,
      endpoint: `/bridge/?${serialize(Object.assign(defaultParams, params))}`,
    },
  };
};

export const initSearchResults = items =>
  Object.assign({ type: TYPES.SEARCH_RESULTS_INIT }, items);

export const paginateSearchResults = pageStart => ({
  type: TYPES.SEARCH_RESULTS_PAGINATE,
  pageStart,
  page: (pageStart / config.paginationDefaults.optionsCount) + 1,
});

export const updateSearchResults = location => ({
  type: TYPES.SEARCH_RESULTS_UPDATE,
  location,
});

export const fetchSearchTopper = (params) => {
  const defaultParams = {
    landing: 'NEED_TO_OVERWRITE_THIS',
  };

  return {
    [CALL_API]: {
      types: [TYPES.SEARCH_TOPPER_REQUEST, TYPES.SEARCH_TOPPER_SUCCESS, TYPES.SEARCH_TOPPER_FAILURE],
      endpoint: `/api/searchTopper?${serialize(Object.assign(defaultParams, params))}`,
    },
  };
};



/** WEBPACK FOOTER **
 ** ./src/redux/actions/searchResultsActions.js
 **/